import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideInfinity'
})
export class HideInfinityPipe implements PipeTransform {
    transform(value: string | null): any {
        if (!value) {
            return '';
        }

        if (value.indexOf('∞') !== -1) {
            return '';
        } else {
            return value;
        }
    }
}
